import type { AuthLoginSuccessResponse } from '../../types/api'
import type { AuthTokens } from '@/modules/Auth/types/model'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export const ENDPOINT = `/admin/Auth/refresh-token`

export async function refreshMutation(payload: AuthTokens) {
  return axiosInstance.post<AuthLoginSuccessResponse['tokens']>(
    ENDPOINT,
    payload
  )
}
